import { c as _c } from "react/compiler-runtime";
import { SALES_FUNNELS_SETTINGS_API } from 'modules/profile/sales-funnels-settings/api/sales-funnels-settings-api';
import { SalesFunnelsSettingsInterface } from 'modules/profile/sales-funnels-settings/types/sales-funnels-settings-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import useSWR from 'swr';
export function useSalesFunnelsSettings() {
  const $ = _c(6);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== user) {
    t1 = () => {
      if (user) {
        return SALES_FUNNELS_SETTINGS_API;
      }
      return null;
    };
    $[1] = user;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    data: salesFunnelData,
    mutate
  } = useSWR(t1, fetcher);
  let t2;
  if ($[3] !== mutate || $[4] !== salesFunnelData) {
    t2 = {
      salesFunnelData,
      mutate
    };
    $[3] = mutate;
    $[4] = salesFunnelData;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}